<template>
	<div>
		<h1>
			{{ event.title }}
		</h1>

		<!-- <div class="row"> -->
			<div class="events-list">
			<event-panel v-for="(childEvent, index) in event.child_events" v-bind:key="index" :event="childEvent"></event-panel>
			</div>
		<!-- </div> -->

		<validation-observer ref="multiRegObserver">
			<div class="row">
				<div class="col-md-6">
					<h2>
						{{ $t('event_registration.title') }}
					</h2>
					<p>
						{{ $t('event_registration.please_complete_you_registration') }}
					</p>
					<p>
						{{ $t('event_registration.once_registration_is_complete') }}<br />
						{{ $t('event_registration.once_registration_is_complete2') }}
						<a href="mailto:events@world-architecs.com">
							events@world-architecs.com
							<i class="wa-arrow wa-arrow-right wa-arrow-small"></i>
						</a>
					</p>
					<event-attendees :attendees="attendees"></event-attendees>
				</div>
				<div class="col-md-6">
					&nbsp;
				</div>
			</div>

			<div class="row">
				<div class="col-md-12">
					&nbsp;
				</div>
			</div>

			<div class="row">
				<div class="col-md-6">
					<div class="checkbox checkbox-default">
						<validation-provider :rules="{ required: { allowFalse: false} }" v-slot="{ failedRules }">
							<input type="checkbox" id="tos" v-model="tosAccepted" name="tos">
							<label for="tos">
								{{ $t('event_registration.tos_label_part1') }}
								<a href="#" v-on:click.prevent="openLegalModal">{{ $t('common.tos') }} <i class="wa-arrow wa-arrow-small"></i></a>
								{{ $t('event_registration.tos_label_part2') }}
								<a :href="tosLink" target="_blank">{{ $t('common.privacy') }} <i class="wa-arrow wa-arrow-small"></i></a>
							</label>
							<input-errors :errors="failedRules" />
						</validation-provider>
					</div>

					<div class="checkbox checkbox-default">
						<input type="checkbox" id="special-mailings" v-model="wantsNewsletter">
						<label for="special-mailings">
							{{ $t('event_registration.information_about_future_events') }}
						</label>
					</div>

					<div>
						<validation-provider :rules="{ required: { allowFalse: false} }" v-slot="{ failedRules }">
							<input type="hidden" v-model="selectedEventsCount" id="events-selected-count">
							<input-errors :errors="failedRules" />
						</validation-provider>
					</div>

					<br />

					<button v-on:click.prevent="submit" id="submit-button" class="btn btn-default">
						{{ $t('common.submit', {}) }}
					</button>
				</div>

				<div class="col-md6">
					&nbsp;
				</div>
			</div>
		</validation-observer>

		<event-registration-agreement-modal :event="event"></event-registration-agreement-modal>
	</div>
</template>

<script>
import EventsApi from 'WaAdminJs/Api/Events';
import EventBus from 'WaAdminJs/Api/EventBus';
import EventRegistrationsApi from 'WaAdminJs/Api/EventRegistrations';
import EventPanel from './EventPanel';
import EventAttendees from './EventAttendees';
import EventRegistrationAgreementModal from './EventRegistrationAgreementModal';

export default {
	name: 'MultiEventRegistration',

	components: {
		EventRegistrationAgreementModal,
		EventAttendees,
		EventPanel
	},

	props: {
		eventId: {
			required: true,
			type: String
		}
	},

	mounted() {
		EventsApi.getEvent(this.eventId).then((result) => {
			this.event = result.data.event;

			// Hack to be able to re-use the same code / component for a single
			// event that doesn't have any child events
			if (this.event.child_events.length === 0) {
				this.event.child_events.push(this.event);
			}
		});

		EventBus.$on('EventRegistration.removeParticipant', (participant) => {
			this.removeParticipant(participant);
		});
	},

	methods: {
		submit: function () {
			let submitButton = document.getElementById('submit-button');
			// Disable the submit button
			submitButton.setAttribute('disabled', 'disabled');

			this.$refs.multiRegObserver.validate().then((success ) => {
				if (success && this.selectedEvents.length > 0) {
					this.sendData();
				} else {
					submitButton.removeAttribute('disabled', 'disabled');
				}
			});
		},
		openLegalModal: function () {
			this.$modal.show('event-registration-agreement-modal');
		},
		removeParticipant(participant) {
			this.attendees.splice(
				this.attendees.indexOf(participant),
				1
			)
		},
		sendData: function() {
			let attendees = [];
			let participants = this.attendees;

			this.attendees.forEach(function (participant) {
				let attendee = Object.assign(participant, {});

				if (participant.companyDiffersFromFirstAttendee !== true) {
					attendee.company_name = participants[0].company_name;
					attendee.company_website = participants[0].company_website;
				}

				attendees.push(attendee);
			});

			EventRegistrationsApi.saveRegistration({
				eventId: this.event.id,
				eventIds: this.selectedEvents,
				attendees: attendees,
				wantsNewsletter: this.wantsNewsletter,
				tosAccepted: this.tosAccepted
			}).then((result) => {
				if (result.status === 200) {
					if (result.data.redirectUrl === undefined) {
						result.data.redirectUrl = this.$App.getLocale() + '/event-regestrations/multiAddConfirmation'
					}
					window.location = result.data.redirectUrl
				}
			});
		}
	},

	computed: {
		selectedEvents: function () {
			if (this.event.child_events === undefined) {
				return [];
			}

			let ids = [];
			this.event.child_events.forEach(function (element) {
				if (element.selected) {
					ids.push(element.id);
				}
			});

			return ids;
		},

		selectedEventsCount: function () {
			return this.selectedEvents.length > 0;
		},
	},

	data: function () {
		return {
			event: {
				locations: {
					tos: null
				}
			},
			attendees: [],
			wantsNewsletter: false,
			tosAccepted: false,
			tosLink: this.$App.getLocale() + '/pages/legal',
			privacyLink: this.$App.getLocale() + '/pages/privacy-statement'
		};
	}
}
</script>

<style>
.events-list {
	display: flex;
	flex-flow: wrap;
}
</style>
